import { ActivatedRoute } from '@angular/router';
import { Component, ViewEncapsulation, Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs/BehaviorSubject";

@Injectable()
export class AppLoadedState {
  isLoaded = new BehaviorSubject(false);

  setLoadedState(val: boolean) {
    this.isLoaded.next(val);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.loaded.state.ts